module.exports = __webpack_public_path__ + "img/apanao.69b04d30.jpg";